module.exports = {
  BASE_URL: 'https://project.bestinbd.com/projects/web/2308MST/dev/api/',
  MAP_API_KEY: 'AIzaSyB3nEqKsliw_EQSpaxAq6R8hOUwpGyxJ9s',
  BULL: '/images/static/vector-1.svg',
  VECTOR2: '/images/static/vector-2.svg',
  VECTOR3: '/images/static/vector-3.svg',
  BLUR: '/images/static/blurbg.svg',
};
